var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoneyPurple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 1.25c4.098 0 7.5 1.701 7.5 4.063v9.375c0 2.36-3.402 4.062-7.5 4.062s-7.5-1.701-7.5-4.063V5.313l.004-.144C2.64 2.882 5.986 1.25 10 1.25zm6.25 12.6-.127.1c-1.366 1.037-3.614 1.675-6.123 1.675-2.509 0-4.757-.638-6.123-1.674l-.127-.1v.836c0 1.403 2.628 2.749 6.007 2.81L10 17.5c3.496 0 6.25-1.377 6.25-2.813v-.836zm0-3.124-.127.1C14.757 11.862 12.51 12.5 10 12.5c-2.509 0-4.757-.638-6.123-1.674l-.127-.1v.836c0 1.403 2.628 2.749 6.007 2.81l.243.003c3.496 0 6.25-1.377 6.25-2.813v-.836zm0-3.125-.127.1C14.757 8.737 12.51 9.375 10 9.375c-2.509 0-4.757-.638-6.123-1.674l-.127-.1v.837c0 1.402 2.628 2.748 6.007 2.81l.243.002c3.496 0 6.25-1.377 6.25-2.813v-.836zM10 2.5c-3.496 0-6.25 1.377-6.25 2.813 0 1.435 2.754 2.812 6.25 2.812s6.25-1.377 6.25-2.813l-.004-.1C16.12 3.814 13.414 2.5 10 2.5z",
    fill: "#8E06BF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyPurple);
export default __webpack_public_path__ + "static/media/money-purple.fa08004446fadae00137fa8f7bbec3bd.svg";
export { ForwardRef as ReactComponent };